var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 26,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#888",
    d: "M8 25.998a7.93 7.93 0 0 1-5.57-2.093A7.53 7.53 0 0 1 0 18.589V5.369a5.45 5.45 0 0 1 1.75-3.846A5.74 5.74 0 0 1 5.773.002a5.74 5.74 0 0 1 4.033 1.517 5.45 5.45 0 0 1 1.754 3.85v13.233a3.44 3.44 0 0 1-1.114 2.316 3.6 3.6 0 0 1-2.44.942 3.6 3.6 0 0 1-2.438-.942 3.44 3.44 0 0 1-1.115-2.316V6.397c0-.345.14-.676.39-.92a1.356 1.356 0 0 1 1.886 0c.25.244.391.575.391.92v12.205a.86.86 0 0 0 .295.546.906.906 0 0 0 1.184 0 .86.86 0 0 0 .294-.546V5.37a2.9 2.9 0 0 0-.976-2.01 3.05 3.05 0 0 0-2.144-.759 3.05 3.05 0 0 0-2.135.764 2.9 2.9 0 0 0-.971 2.005v13.219a4.97 4.97 0 0 0 1.647 3.479c1 .9 2.325 1.38 3.686 1.33a5.23 5.23 0 0 0 3.686-1.33 4.97 4.97 0 0 0 1.647-3.48V5.37c0-.345.14-.676.39-.92a1.357 1.357 0 0 1 1.887 0c.25.244.39.575.39.92v13.219a7.53 7.53 0 0 1-2.43 5.316A7.93 7.93 0 0 1 8 25.998"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.aead735ff72bca2471c5b6027dd1c2db.svg";
export { ForwardRef as ReactComponent };